import { common } from './common';
import { tickets } from './tickets';
import { workflow } from './workflow';
import { masterData } from './masterData';
import { licences } from './licences';
import { users } from './users';
import { diagnostics } from './diagnostics';
import { tutorial } from './tutorial';

// Each key lives in exactly one feature file; keys used by several features or built dynamically live in common.
export const hu: Record<string, string> = {
  ...common,
  ...tickets,
  ...workflow,
  ...masterData,
  ...licences,
  ...users,
  ...diagnostics,
  ...tutorial,
};
